import { createContext, useContext } from 'react';

// Listener arguments are inferred from the callback passed by the caller.
export type VibeWebsocketListener<A extends unknown[] = unknown[]> = (...args: A) => void;

export interface VibeWebsocketContextType {
  connected: boolean;
  on: <A extends unknown[]>(event: string, callback: VibeWebsocketListener<A>) => void;
  off: <A extends unknown[]>(event: string, callback?: VibeWebsocketListener<A>) => void;
  emit: (event: string, ...args: unknown[]) => void;
  connect: () => void;
  disconnect: () => void;
}

export const VibeWebsocketContext = createContext<VibeWebsocketContextType | null>(null);

export const useVibeWebsocket = (): VibeWebsocketContextType => {
  const context = useContext(VibeWebsocketContext);
  if (!context) {
    throw new Error('useVibeWebsocket must be used within a VibeWebsocketProvider');
  }
  return context;
};
